export default {
	serviceProvider: null,
	vuexModule: "reports",
	queryParams: {
		company_id: null,
		assignee: "Corporate Admin",
	},
	headerColumns: [
		{
			prop: "name_OR_report",
			keys: ["name", "report.name"],
			label: "Report Name",
			minWidth: 200,
			searchable: true,
			sortable: true,
			sortBy: "name",
		},
	],
};
